import React, { useState, useRef, useEffect } from "react";
import '../../../scss/TypeTracNghiem.scss'
import he from 'he';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ThiTrucTuyenService } from 'services/ThiTrucTuyenService';
import { Toast } from 'primereact/toast';

const TypeSapXepReview = (props) => {
    const { data, overview, userId } = props;
    let arrAnswer = null;
    if (data.selected != null && data.selected.vanbantraloi && data.selected.vanbantraloi.trim() !== "") {
        try {
            const arr = JSON.parse(data.selected.vanbantraloi);
            arrAnswer = arr;
        } catch (error) {
            console.error('Error parsing vanbantraloi:', error);
            console.error('vanbantraloi value:', data.selected.vanbantraloi);
            arrAnswer = null;
        }
    }
    const exampleAnswer = (data?.lstdapan || []).find(item => item.is_example == 1);
    const nonExampleAnswers = (data?.lstdapan || []).filter(item => item.is_example != 1);
    const initialData = {
        table1: [
            exampleAnswer ? { ...exampleAnswer, _isExample: true } : { vanbanphanhoi: "" },
            { vanbanphanhoi: "" },
            { vanbanphanhoi: "" },
            { vanbanphanhoi: "" },
            { vanbanphanhoi: "" },
            { vanbanphanhoi: "" },
        ],
        table2: nonExampleAnswers
    };
    const [lstDapAn, setlstDapAn] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dataDrop, setDataDrop] = useState(arrAnswer || initialData);
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const toast = useRef(null);
    const IdDeThi = localStorage.getItem('IdDeThi');

    const submitQuestion = async (strData) => {
        const body = {
            user_id: userId,
            id_cauhoi: data.id,
            vanbantraloi: strData,
            loaibaithi: 1,
            attempt_code: localStorage.getItem('exam_attempt_code') || null,
            dethitructuyen_id: localStorage.getItem('IdDeThi'),
            type_exam: localStorage.getItem('typeExam')
        }
        await ThiTrucTuyenService.submitquestionsx(body);
    }


    const onDragEnd = (result) => {
        if (!result.destination) return;

        const sourceTable = result.source.droppableId;
        const destTable = result.destination.droppableId;
        const destinationIndex = result.destination.index;

        if (sourceTable === 'table2' && destTable === 'table1' && destinationIndex > 0 && destinationIndex < dataDrop.table1.length) {
            const sourceItems = Array.from(dataDrop[sourceTable]);
            const destItems = Array.from(dataDrop[destTable]);

            const [movedItem] = sourceItems.splice(result.source.index, 1);
            const replacedItem = destItems[destinationIndex];
            destItems[destinationIndex] = movedItem;

            if (replacedItem.vanbanphanhoi !== "") {
                sourceItems.push(replacedItem);
            }

            setDataDrop({
                table1: destItems,
                table2: sourceItems
            });
            let arr = {
                table1: destItems,
                table2: sourceItems
            }
            const jsonString = JSON.stringify(arr);
            submitQuestion(jsonString);

        } else if (sourceTable === 'table1' && destTable === 'table1') {
            if (result.source.index === 0 || destinationIndex === 0) return;

            const items = Array.from(dataDrop[sourceTable]);
            const [movedItem] = items.splice(result.source.index, 1);
            items.splice(destinationIndex, 0, movedItem);

            const newState = { ...dataDrop, [sourceTable]: items };
            setDataDrop(newState);
            submitQuestion(JSON.stringify(newState));

        } else if (sourceTable === 'table1' && destTable === 'table2' && dataDrop.table1[result.source.index]) {
            if (result.source.index === 0) return;
            const sourceItems = Array.from(dataDrop[sourceTable]);
            const destItems = Array.from(dataDrop[destTable]);
            if (sourceItems[result.source.index].vanbanphanhoi !== "") {
                const [movedItem] = sourceItems.splice(result.source.index, 1);
                destItems.splice(destinationIndex, 0, movedItem);

                sourceItems.splice(result.source.index, 0, { vanbanphanhoi: "" });

                setDataDrop({
                    table1: sourceItems,
                    table2: destItems
                });
                let arr = {
                    table1: sourceItems,
                    table2: destItems
                }
                const jsonString = JSON.stringify(arr);
                submitQuestion(jsonString);
            }

        } else if (sourceTable === 'table2' && destTable === 'table2') {
            const items = Array.from(dataDrop[sourceTable]);
            const [movedItem] = items.splice(result.source.index, 1);
            items.splice(destinationIndex, 0, movedItem);

            const newState = { ...dataDrop, [sourceTable]: items };
            setDataDrop(newState);
            submitQuestion(JSON.stringify(newState));
        }
    };

    const toggleAudio = async () => {
        try {
            const el = audioRef.current;
            if (!el) return;

            const playCountKey = `playCount_${userId}_${data.id}_${IdDeThi}`;
            const currentCount = parseInt(localStorage.getItem(playCountKey) || '0');

            if (isPlaying) {
                el.pause();
                setIsPlaying(false);
            } else {
                if (currentCount >= 2) {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Notice',
                        detail: 'You have reached the maximum number of listens for this question (max 2 times).',
                        life: 3000
                    });
                    return;
                }

                el.currentTime = 0;
                await el.play();
                setIsPlaying(true);

                const newCount = currentCount + 1;
                localStorage.setItem(playCountKey, newCount);
            }
        } catch (e) {
        }
    };

    useEffect(() => {
        setLoading(true);
        let newarrr = [...(data?.lstdapan || [])];
        setlstDapAn(newarrr);
        if (arrAnswer == null) {
            const exAns = newarrr.find(item => item.is_example == 1);
            const nonExAns = newarrr.filter(item => item.is_example != 1);
            let initialData = {
                table1: [
                    exAns ? { ...exAns, _isExample: true } : { vanbanphanhoi: "" },
                    { vanbanphanhoi: "" },
                    { vanbanphanhoi: "" },
                    { vanbanphanhoi: "" },
                    { vanbanphanhoi: "" },
                    { vanbanphanhoi: "" },
                ],
                table2: nonExAns
            };
            setDataDrop(initialData);
        }
        setTimeout(() => {
            setLoading(false);
        }, 1000);

    }, [])

    return (
        <>
            <div className="conatiner-div1">
                {
                    loading
                        ?
                        <div style={{ textAlign: 'center' }}>
                            <ProgressSpinner />
                        </div>
                        :
                        <div>
                            <div style={{ marginTop: '16px', marginBottom: '8px' }}>
                                {data.ma == "NGHE" && data.file &&
                                    <div style={{ marginTop: '20px', width: '100%' }}>
                                        <audio
                                            controlsList="nodownload"
                                            key={data.id}
                                            ref={audioRef}
                                            style={{ display: 'none' }}
                                            onEnded={() => setIsPlaying(false)}
                                        >
                                            <source src={data.file} type="audio/ogg" />
                                            <source src={data.file} type="audio/mpeg" />
                                        </audio>
                                        <button
                                            type="button"
                                            className="btn-audio-toggle"
                                            onClick={toggleAudio}
                                        >
                                            <span className="icon">{isPlaying ? '⏸' : '⏵'}</span>
                                            <span className="text">
                                                <u>{isPlaying ? 'Stop' : 'Play'}</u>
                                            </span>
                                        </button>
                                    </div>
                                }
                            </div>
                            <div className="mt-3" style={{ display: 'flex', justifyContent: 'center', gap: '5%', marginTop: '20px' }}>
                                {
                                    overview ?
                                        <div style={{ width: '100%' }}>
                                            <div style={{ overflow: 'hidden', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                                                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0' }}>
                                                    <thead>
                                                        <tr>
                                                            <th style={{
                                                                textAlign: 'center',
                                                                fontWeight: '600',
                                                                fontSize: '15px',
                                                                border: 'none',
                                                                padding: '16px',
                                                                width: '50%',
                                                                backgroundColor: '#23085a',
                                                                color: '#fff'
                                                            }}>
                                                                Your answer
                                                            </th>
                                                            <th style={{
                                                                textAlign: 'center',
                                                                fontWeight: '600',
                                                                fontSize: '15px',
                                                                border: 'none',
                                                                padding: '16px',
                                                                width: '50%',
                                                                backgroundColor: '#dc3545',
                                                                color: '#fff'
                                                            }}>
                                                                Correct answer
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {dataDrop.table1.map((item, index) => {
                                                            const isCorrect = (item.id || item.vanbanphanhoi) === (lstDapAn[index]?.id || lstDapAn[index]?.vanbanphanhoi);
                                                            
                                                            return (
                                                                <tr key={index} style={{
                                                                    backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa',
                                                                    transition: 'background-color 0.2s ease'
                                                                }}>
                                                                    <td style={{
                                                                        border: '1px solid #e9ecef',
                                                                        padding: '14px 16px',
                                                                        verticalAlign: 'top'
                                                                    }}>
                                                                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                                            <span style={{
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                width: '26px',
                                                                                height: '26px',
                                                                                borderRadius: '50%',
                                                                                backgroundColor: isCorrect ? '#28a745' : '#dc3545',
                                                                                color: '#fff',
                                                                                fontWeight: '600',
                                                                                fontSize: '13px',
                                                                                flexShrink: 0
                                                                            }}>
                                                                                {index}
                                                                            </span>
                                                                            <div
                                                                                dangerouslySetInnerHTML={{ __html: item.vanbanphanhoi || '<span style="color: #999; font-style: italic;">Not answered</span>' }}
                                                                                style={{
                                                                                    flex: 1,
                                                                                    lineHeight: '1.6',
                                                                                    color: item.vanbanphanhoi ? '#333' : '#999',
                                                                                    fontSize: '14px'
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </td>

                                                                    <td style={{
                                                                        border: '1px solid #e9ecef',
                                                                        padding: '14px 16px',
                                                                        verticalAlign: 'top'
                                                                    }}>
                                                                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                                            <span style={{
                                                                                display: 'inline-flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                width: '26px',
                                                                                height: '26px',
                                                                                borderRadius: '50%',
                                                                                backgroundColor: '#dc3545',
                                                                                color: '#fff',
                                                                                fontWeight: '600',
                                                                                fontSize: '13px',
                                                                                flexShrink: 0
                                                                            }}>
                                                                                {index}
                                                                            </span>
                                                                            <div
                                                                                dangerouslySetInnerHTML={{ __html: lstDapAn[index]?.vanbanphanhoi || '' }}
                                                                                style={{
                                                                                    flex: 1,
                                                                                    lineHeight: '1.6',
                                                                                    color: '#333',
                                                                                    fontSize: '14px'
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        :
                                        <DragDropContext onDragEnd={onDragEnd}>
                                            {['table1', 'table2'].map((tableId) => (
                                                <Droppable key={tableId} droppableId={tableId}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.droppableProps}
                                                            style={{
                                                                width: '50%',
                                                                padding: '16px',
                                                                border: snapshot.isDraggingOver
                                                                    ? '2px dashed #23085a'
                                                                    : '2px solid #e0e0e0',
                                                                borderRadius: '14px',
                                                                minHeight: '200px',
                                                                backgroundColor: snapshot.isDraggingOver
                                                                    ? '#e7f3ff'
                                                                    : tableId === 'table1'
                                                                        ? '#ffffff'
                                                                        : '#eee8f5',
                                                                boxShadow: snapshot.isDraggingOver
                                                                    ? '0 8px 20px rgba(0, 92, 185, 0.15)'
                                                                    : '0 4px 12px rgba(0,0,0,0.08)',
                                                                transition: 'all 0.3s ease',
                                                                position: 'relative'
                                                            }}
                                                        >
                                                            <div style={{
                                                                marginBottom: '16px',
                                                                paddingBottom: '12px',
                                                                borderBottom: '2px solid #e9ecef'
                                                            }}>
                                                                <h3 style={{
                                                                    margin: 0,
                                                                    fontSize: '15px',
                                                                    fontWeight: '600',
                                                                    color: tableId === 'table1' ? '#23085a' : '#23085a',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '8px'
                                                                }}>
                                                                    <span style={{
                                                                        display: 'inline-block',
                                                                        width: '8px',
                                                                        height: '8px',
                                                                        borderRadius: '50%',
                                                                        backgroundColor: tableId === 'table1' ? '#23085a' : '#23085a'
                                                                    }}></span>
                                                                    {tableId === 'table1' ? 'Drag and drop here to arrange' : 'Answer list'}
                                                                </h3>
                                                            </div>

                                                            {dataDrop[tableId].map((item, index) => (
                                                                <Draggable
                                                                    key={tableId + '-' + index}
                                                                    draggableId={tableId + '-' + index}
                                                                    index={index}
                                                                    isDragDisabled={(tableId === 'table1' && item.vanbanphanhoi === "") || (tableId === 'table1' && item._isExample === true)}
                                                                >
                                                                    {(provided, snapshot) => (
                                                                        <div
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            style={{
                                                                                userSelect: 'none',
                                                                                padding: item.vanbanphanhoi ? '8px 12px' : '8px',
                                                                                margin: '6px 0',
                                                                                border: item.vanbanphanhoi
                                                                                    ? snapshot.isDragging
                                                                                        ? '2px solid #23085a'
                                                                                        : '2px solid #d0d7de'
                                                                                    : '2px dashed #cbd5e0',
                                                                                borderRadius: '10px',
                                                                                backgroundColor: item.vanbanphanhoi
                                                                                    ? snapshot.isDragging
                                                                                        ? '#e7f3ff'
                                                                                        : '#ffffff'
                                                                                    : '#f8f9fa',
                                                                                transition: 'all 0.2s ease',
                                                                                cursor: tableId === 'table1' && item.vanbanphanhoi === "" ? 'not-allowed' : 'grab',
                                                                                boxShadow: snapshot.isDragging
                                                                                    ? '0 6px 16px rgba(0, 92, 185, 0.25)'
                                                                                    : item.vanbanphanhoi
                                                                                        ? '0 2px 6px rgba(0,0,0,0.08)'
                                                                                        : 'none',
                                                                                transform: snapshot.isDragging ? 'rotate(1deg) scale(1.02)' : 'none',
                                                                                ...provided.draggableProps.style,
                                                                                zIndex: snapshot.isDragging ? 1000 : 0
                                                                            }}
                                                                        >
                                                                            {item.vanbanphanhoi ? (
                                                                                <div style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'flex-start',
                                                                                    gap: '12px'
                                                                                }}>
                                                                                    <span style={{
                                                                                        display: 'inline-flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        width: '26px',
                                                                                        height: '26px',
                                                                                        borderRadius: '50%',
                                                                                        backgroundColor: tableId === 'table1' ? '#23085a' : '#23085a',
                                                                                        color: '#fff',
                                                                                        fontWeight: '600',
                                                                                        fontSize: '13px',
                                                                                        flexShrink: 0
                                                                                    }}>
                                                                                        {tableId === 'table1' ? index : index + 1}
                                                                                    </span>
                                                                                    <div
                                                                                        style={{
                                                                                            flex: 1,
                                                                                            lineHeight: '1.6',
                                                                                            color: '#333',
                                                                                            fontSize: '14px'
                                                                                        }}
                                                                                        dangerouslySetInnerHTML={{ __html: item.vanbanphanhoi }}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    minHeight: '30px',
                                                                                    color: '#999',
                                                                                    fontStyle: 'italic',
                                                                                    fontSize: '13px'
                                                                                }}>
                                                                                    Drag answer here
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            ))}
                                                            {provided.placeholder}
                                                        </div>
                                                    )}
                                                </Droppable>
                                            ))}
                                        </DragDropContext>
                                }

                            </div>
                        </div>
                }


            </div>


            <Toast ref={toast} />
        </>
    );
}

export default TypeSapXepReview;
